module.exports = __webpack_public_path__ + "img/icon_01.59466404.svg";